import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function SeoContextFooter({ label, to, onClick, children, className = "" }) {
  const classes = ["seo-context-footer", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <span className="seo-context-footer__label">{label}</span>
      <Link to={to} onClick={onClick} className="seo-context-footer__anchor">
        {children}
        <ArrowRight size={14} weight="bold" aria-hidden="true" />
      </Link>
    </div>
  );
}
